import { observer } from 'mobx-react';
import Counter2_0 from './Counter2_0';
import Counter2_1 from './Counter2_1';
import Counter2_2 from './Counter2_2';
import { emptyFragment } from '../../../../../../../../EmptyFragment';

interface Props {
  utilized: number;
}

function TwoOfferingTypes({ utilized }: Props) {
  switch (utilized) {
    case 0:
      return <Counter2_0 />;
    case 1:
      return <Counter2_1 />;
    case 2:
      return <Counter2_2 />;
    default:
      return emptyFragment();
  }
}

export default observer(TwoOfferingTypes);
